/*
 * A contents rail for guide articles, built from the piece's own h2s so it
 * cannot drift from the headings it lists.
 *
 * Why it exists: the strongest competitor in this category runs a linked
 * table of contents on every piece, and long articles without one are read
 * as a wall. Authoring one by hand per post would go stale the first time a
 * heading is reworded.
 *
 * Progressive enhancement: with JavaScript off the article reads exactly as
 * it does now, one column, nothing missing.
 *
 * Ported from the sibling Kensington build, including its scroll-position
 * fix. The rAF guard below resets inside the callback, which matters: the
 * same pattern with the reset outside latches permanently the first time rAF
 * is throttled, and killed two scroll animations in this project before it
 * was traced. See THEME-TRAPS.md F17.
 */
(function () {
  var body = document.querySelector('.blog-post-content');
  if (!body) return;

  var headings = Array.prototype.filter.call(
    body.querySelectorAll('h2'),
    function (h) {
      return h.textContent.trim().length;
    }
  );

  // Two headings is a list of two, which is not worth a rail.
  if (headings.length < 3) return;

  var slug = function (text, i) {
    var s = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    return s ? s.slice(0, 48) : 'section-' + (i + 1);
  };

  var nav = document.createElement('nav');
  nav.className = 'pp-contents';
  nav.setAttribute('aria-labelledby', 'pp-contents-title');

  var title = document.createElement('h2');
  title.className = 'pp-contents__title';
  title.id = 'pp-contents-title';
  title.textContent = 'In this guide';
  nav.appendChild(title);

  var list = document.createElement('ol');
  list.className = 'pp-contents__list';

  headings.forEach(function (h, i) {
    if (!h.id) h.id = slug(h.textContent.trim(), i);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  nav.appendChild(list);
  body.parentNode.insertBefore(nav, body);
  document.documentElement.setAttribute('data-pp-article', 'contents');

  var links = {};
  Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
    links[a.getAttribute('href').slice(1)] = a;
  });

  /*
   * The current section is the last heading that has passed the reading line,
   * computed from positions rather than from an IntersectionObserver band.
   * The band version compared a heading's viewport top against the observer's
   * own reduced root height - two different coordinate systems - so a heading
   * whose entry and exit both fell outside that comparison never registered.
   * The last section of every piece was one such heading.
   */
  var READING_LINE = 0.32; // of the viewport, from the top

  var current = null;
  var mark = function () {
    var line = window.innerHeight * READING_LINE;
    var found = null;

    headings.forEach(function (h) {
      if (h.getBoundingClientRect().top <= line) found = h.id;
    });

    // Past the end of the piece the last heading stays lit rather than going
    // out, which is what a reader at the bottom expects to see.
    if (!found && headings.length) {
      var first = headings[0].getBoundingClientRect();
      if (first.top < 0) found = headings[headings.length - 1].id;
    }

    if (found === current) return;
    current = found;

    Object.keys(links).forEach(function (id) {
      if (id === current) links[id].setAttribute('aria-current', 'true');
      else links[id].removeAttribute('aria-current');
    });
  };

  var queued = false;
  var onScroll = function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      mark();
    });
  };

  // Above 990px this theme scrolls inside .page-wrapper, not the window, so
  // a window-only listener never fires on desktop.
  var scroller = document.querySelector('.page-wrapper');
  window.addEventListener('scroll', onScroll, { passive: true });
  if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  mark();
})();
